import axios from "axios/index";

export default {
  createTrigger: ({commit}, payload) => {
    commit('ui/SHOW_OVERLAY', true, {root: true});
    axios({
      url: '/engine/triggers',
      method: "POST",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        commit('triggers/ADD_TRIGGER', response.data, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        /* eslint-disable */
        console.log(err);
      });
  },
  modifyTrigger: ({commit}, payload) => {
    commit('ui/SHOW_OVERLAY', true, {root: true});
    axios({
      url: '/engine/triggers/' + payload.id,
      method: "PUT",
      data: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        commit('triggers/MODIFY_TRIGGER', response.data, {root: true});
        commit('ui/HIDE_OVERLAY', true, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteTrigger: ({commit}, id) => {
    commit('ui/SHOW_OVERLAY', true, {root: true});
    axios({
      url: '/engine/triggers/' + id,
      method: "DELETE"
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', true, {root: true});
        /* eslint-disable */
        console.log(err);
      });
  }
};